import $ from "jquery";
import { getConfig, createGuid, articlesExtend } from "#scripts/general_functions";
import { getLangForApi } from "#scripts/cmsapi.js";

export const warningHtml = (info, where) => {
	return `
                <div class="container p-md-0 alert_main__container ${where}" data-warningid="${info.guid}">
                    <div class="row">
                        <div class="col-sm-12">
                            <div class="alert alert-dismissible alert__main alert__main-${info.cssClass}" role="alert">
                                <button type="button" class="close alert__main__close" data-dismiss="${info.guid}" data-contentid="${info.contentId}" aria-label="Close">
                                    <span class="material-close-ui">&nbsp;</span>
                                </button>
                                <div class="row">
                                    <div class="col-12 col-md-2 col-lg-1 pr-sm-0 alert__main__iconplacement">
                                    ${info.icon}
                                    </div>
                                    <div class="col-12 pl-sm-0 pr-sm-5 col-md-10 col-lg-11">
                                        <h2 class="alert__main__title">${info.title}</h2>
                                        <div class="alert__main__text">${info.content}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>`;
};

export const setWarning = (warnings) => {
	let messages = [];

	if (warnings?.totalCount > 0 && warnings.listOfContent.length > 0) {
		// if (checkNested(warnings, "listOfContent", "0", "title")) {
		for (const item of warnings.listOfContent) {
			const extendItem = articlesExtend(item);

			let type = "Drift";
			let placement = "Hele portalen";
			const warnPages = [];
			const title = extendItem.title;
			// const content = decodeURIComponent(extendItem.contentObject);
			let content = extendItem.contentObject;
			content = content.replace("aim:", "/artikkel/");
			// const intro = extendItem.intro;
			// const articleId = window.contentID;
			const articleId = window.articleParsed.contentId;
			// let retArray = [];
			const guid = createGuid();

			const types = {
				Drift: {
					cssClass: "info",
					icon: `<svg class="alert__main__icon" xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 54 54">
                    <g fill="none" fill-rule="evenodd">
                        <g fill-rule="nonzero">
                            <g>
                                <g>
                                    <g>
                                        <g fill="#FFF" transform="translate(-172 -472) translate(150 440) translate(0 10) translate(22 22)">
                                            <circle cx="27" cy="27" r="27"/>
                                        </g>
                                        <path fill="#1E1E1E" d="M27 18.86c.907 0 1.634-.267 2.18-.802.547-.535.82-1.244.82-2.128 0-.883-.273-1.593-.82-2.128C28.634 13.267 27.907 13 27 13c-.884 0-1.605.273-2.163.82-.558.546-.837 1.25-.837 2.11 0 .86.28 1.564.837 2.11.558.547 1.28.82 2.163.82zm1.884 21.64c.395 0 .593-.198.593-.593V23.163c0-.396-.198-.593-.593-.593H25.15c-.395 0-.593.197-.593.593v16.744c0 .395.198.593.593.593h3.733z" transform="translate(-172 -472) translate(150 440) translate(0 10) translate(22 22)"/>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </g>
                </svg>`,
				},
				"Mindre viktig": {
					cssClass: "warning",
					icon: `<svg class="alert__main__icon" xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 54 54">
          <g fill="none" fill-rule="evenodd">
              <g fill-rule="nonzero">
                  <g>
                      <g>
                          <g>
                              <g transform="translate(-172 -628) translate(150 440) translate(0 10) translate(0 156) translate(22 22)">
                                  <circle cx="27" cy="27" r="27" fill="#000000"/>
                                  <path fill="#fff" d="M28.631 32.624c.512 0 .768-.242.768-.725l.555-18.174c0-.483-.228-.725-.683-.725h-4.565c-.455 0-.682.242-.682.725l.512 18.174c0 .483.242.725.725.725h3.37zM26.882 42.82c1.11 0 2.04-.363 2.794-1.088.754-.725 1.13-1.6 1.13-2.624 0-.995-.397-1.856-1.194-2.58-.796-.726-1.706-1.089-2.73-1.089s-1.927.363-2.709 1.088c-.782.725-1.173 1.586-1.173 2.581 0 1.024.37 1.899 1.11 2.624.739.725 1.663 1.088 2.772 1.088z"/>
                              </g>
                          </g>
                      </g>
                  </g>
              </g>
          </g>
      </svg>`,
				},
				Viktig: {
					cssClass: "alert",
					icon: `<svg class="alert__main__icon" xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 54 54">
                  <g fill="none" fill-rule="evenodd">
                      <g fill-rule="nonzero">
                          <g>
                              <g>
                                  <g transform="translate(-172 -776) translate(150 440) translate(0 314) translate(22 22)">
                                      <circle cx="27" cy="27" r="27" fill="var(--alert__main__icon_bg, #D0021B)" />
                                      <path fill="#FFF" d="M28.631 32.624c.512 0 .768-.242.768-.725l.555-18.174c0-.483-.228-.725-.683-.725h-4.565c-.455 0-.682.242-.682.725l.512 18.174c0 .483.242.725.725.725h3.37zM26.882 42.82c1.11 0 2.04-.363 2.794-1.088.754-.725 1.13-1.6 1.13-2.624 0-.995-.397-1.856-1.194-2.58-.796-.726-1.706-1.089-2.73-1.089s-1.927.363-2.709 1.088c-.782.725-1.173 1.586-1.173 2.581 0 1.024.37 1.899 1.11 2.624.739.725 1.663 1.088 2.772 1.088z"/>
                                  </g>
                              </g>
                          </g>
                      </g>
                  </g>
              </svg>`,
				},
			};

			if (extendItem.metaParsed) {
				const itemParsed = extendItem.metaParsed;

				if (itemParsed.beredskapAlvorlighetsgrad) {
					type = itemParsed.beredskapAlvorlighetsgrad;
				}
				if (itemParsed.beredskapPlassering) {
					const itemPlacement = itemParsed.beredskapPlassering;

					if (itemPlacement.beredskapVisPaaSide) {
						placement = itemPlacement.beredskapVisPaaSide;
					}

					if (placement === "Underside") {
						const selectedItems = itemPlacement.beredskapSelectedItems;

						if (selectedItems) {
							if (selectedItems.length > 0) {
								for (const placethis of selectedItems) {
									warnPages.push(placethis.contentId);
								}
							}
						}
					}
				}
			}

			const itemHtml = warningHtml(
				{
					title,
					content,
					cssClass: types[type].cssClass,
					icon: types[type].icon,
					guid,
					contentId: extendItem.contentId,
				},
				placement.replace(" ", "").toLowerCase(),
			);

			if (placement === "Underside") {
				if (warnPages.indexOf(articleId) > -1) {
					messages.push(itemHtml);
				}
			} else if (
				placement === "Forside" &&
				(window.serverdata.configMeta.aim.template === "frontpage" || window.serverdata.articleInfo.contentId === window.serverdata.configMeta.aim.frontpage)	
			) {
				messages.push(itemHtml);
			} else if (placement === "Hele portalen") {
				// hele portalen
				messages.push(itemHtml);
			}
		}
	}

	messages = messages.join("");
	return messages;
};

export const getApiWarnings = () => {
	const clientid = getConfig().clientId;
	const apiCall = `${window.apiUrl}/Public/articles`;
	const apiParameters = `?subscriptionId=${clientid}&pageType=mal_beredskap&language=${getLangForApi()}`;

	// if (window.warnings) {
	$.when($.getJSON(apiCall + apiParameters)).done((warnings) => {
		window.warnings = warnings;
		const messages = setWarning(warnings);
		$("#warnings_container").html(messages);
	});
	// } else {
	// 	const messages = setWarning(window.warnings);
	// 	$("#warnings_container").html(messages);
	// }
	$("body").on("click", ".alert__main__close", function () {
		const id = $(this).data("dismiss");
		const contentId = $(this).data("contentid");
		$(`[data-warningid=${id}]`).addClass("d-none");
		sessionStorage.setItem(`hide-warning-${contentId}`, Date.now());
	});
};
